import React, { useState, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { 
  FaSave, FaSpinner, FaExclamationTriangle,
  FaMoneyBillWave, FaCreditCard, FaMobileAlt,
  FaUniversity, FaWallet, FaInfoCircle,
  FaCheckCircle, FaTimesCircle, FaChevronDown
} from 'react-icons/fa';
import './CreatePaymentMethod.css';

// API Configuration
const API_BASE_URL = 'http://localhost:8000/api';

// SweetAlert2 Configuration
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true
});

const SavingsAnalysis = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    notes: '',
    payment_type: 'bank_transfer',
    balance: 0
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');
  const [tokenExpired, setTokenExpired] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(false);


  // Load user data on component mount
  useEffect(() => {
    const loadUserData = () => {
      try {
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
          const parsedUserData = JSON.parse(storedUserData);
          setUserData(parsedUserData);
          console.log('Loaded user data:', parsedUserData);
        } 
      } catch (error) {
        console.error('Error loading user data:', error);
        setTokenExpired(true);
      }
    };

    loadUserData();
  }, []);
  
  return (
    <Layout>
      <div className="create-payment-method">
        <div className="page-header">
          <h2>Savings Goals Analysis</h2>
          <p>Track your savings goals.</p>
        </div>

      </div>
    </Layout>
  );
};

export default SavingsAnalysis;
